import { render } from "./FindCompany.vue?vue&type=template&id=54af2c40&scoped=true&ts=true"
import script from "./FindCompany.vue?vue&type=script&lang=ts"
export * from "./FindCompany.vue?vue&type=script&lang=ts"

import "./FindCompany.vue?vue&type=style&index=0&id=54af2c40&lang=scss&scoped=true"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54af2c40"]])

export default __exports__